<script>
    import { createEventDispatcher } from "svelte";

    export let bookmark;

    let dispatch = createEventDispatcher();
</script>

<div class="buttons">
    {#if bookmark}
        <div class="buttons__bookmark">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="h-4 w-4"
            >
                <path
                    fill-rule="evenodd"
                    d="M6.32 2.577a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93V21a.75.75 0 0 1-1.085.67L12 18.089l-7.165 3.583A.75.75 0 0 1 3.75 21V5.507c0-1.47 1.073-2.756 2.57-2.93Z"
                    clip-rule="evenodd"
                />
            </svg>
        </div>
    {/if}
    <button class="btn" on:click={() => dispatch("cancel")}>Cancel</button>
    <button class="btn" on:click={() => dispatch("confirm")}>Create</button>
</div>

<style>
    @import "../../main.css";

    .buttons {
        @apply reset flex justify-end border border-t border-gray-200 px-2 py-2 !important;
    }

    .buttons__bookmark {
        @apply reset mr-auto flex h-4 w-4 self-center text-gray-300 !important;
    }

    .btn {
        @apply reset rounded border-none px-2 py-1 text-xs font-normal text-black no-underline hover:bg-gray-200 focus:outline-none !important;
    }

    .btn::before {
        @apply reset content-none !important;
    }

    .btn:after {
        @apply reset content-none !important;
    }

    .btn.right {
        @apply ml-auto !important;
    }
</style>
